// extracted by mini-css-extract-plugin
export var carrierNotice = "_lp-5";
export var carrierNoticePlaceholder = "_lp-6";
export var deliveryRow = "_lp-c";
export var fixedHeight = "_lp-4";
export var freightLogo = "_lp-b";
export var fullWidth = "_lp-3";
export var priceColumn = "_lp-7";
export var radioSelected = "_lp-9";
export var radioUnselected = "_lp-8";
export var selectedOption = "_lp-2";
export var selectedOptionContainer = "_lp-1";
export var selection = "_lp-0";
export var tallSkeletonText = "_lp-a";